import { Injectable } from '@angular/core';
import {
  CanActivate,
  Router,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  ActivatedRoute
} from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { Observable } from 'rxjs';
import { User } from '../models/data/user.model';
import { RootState } from '../store/root.reducer';
import { Store } from '@ngrx/store';
import { selectUser } from '../store/user/selectors/user.selectors';
import { ComponentSubscriber } from './subscriber.component';
import { localStorageIsValid } from './utils';

@Injectable()
export class CanActivateGuard extends ComponentSubscriber implements CanActivate {

  constructor(
    private router: Router,
    private cookies: CookieService,
    private route: ActivatedRoute,
    private store: Store<RootState>,
  ) {
    super()
  }

  // login already, go to pages
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): boolean {
    let result = false
    if(!localStorageIsValid(`omis_remember_account`)){
      result = true
    }
    // this.user$ = this.store.select(selectUser)
    // const getUserLgoin$ =
    //   this.user$.subscribe(c => {
    //     if(c == null){
    //       result = true
    //     }
    //   })

    // this.subscriptions.push({
    //   subscription: getUserLgoin$,
    //   name: 'Get User Login'
    // })
    if(!result){
      this.router.navigate(["../pages"],{ relativeTo: this.route })
    }
    return result
  }

  //no login, go to pages; login stay
  canActivateChild(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): boolean {
    let result = true
    if(!localStorageIsValid(`omis_remember_account`)){
      result = false
    }
    // this.user$ = this.store.select(selectUser)
    // const getUserLgoin$ =
    //   this.user$.subscribe(c => {
    //     if(c === null){
    //       result = false
    //     }
    //   })

    // this.subscriptions.push({
    //   subscription: getUserLgoin$,
    //   name: 'Get User Login'
    // })
    if(!result){
      this.router.navigate(["../log-in"],{ relativeTo: this.route })
    }
    return result
  }
}
